// JS file for CombinationProduct
